import * as React from "react";
import { IContextApiModel } from "./apiModels/IContextApiModel";

// ReSharper disable InconsistentNaming

export const GlobalContext = React.createContext<IContextApiModel | null>(null);